<template>
  <b-col sm="12" :lg="size" :offset="offset">
    <DateModal
      v-if="chartType != 'Shipped'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <DateProductManufacturerModal
      v-if="chartType === 'Shipped'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDateProductPickerModalEmit"
    ></DateProductManufacturerModal>
    <b-card class="backClass" style="min-height: 587px">
      <div
        slot="header"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <HeaderTitle
          :title="title"
          :dateFrom="from ? from : dateFrom"
          :dateTo="to ? to : dateTo"
          :chartType="chartType"
        ></HeaderTitle>
        <HeaderControl
          :showFullscreenIcon="true"
          :showDateIcon="true"
          :showDownloadPdfIcon="true"
          :showDownloadExcelIcon="chartType === 'recycled'"
          :chartType="chartType"
          @emit-fullscreen="toggleFullScreen"
          @emit-date="modalDateEvent(chartType)"
          @emit-last-month="setLastMonth"
          @emit-pdf-download="downloadPDF"
          @emit-excel-download="downloadRecycledExcel"
        ></HeaderControl>
      </div>
      <div
        style="width: 100%; display: flex; justify-content: flex-end"
        v-if="withFinancial"
      >
        <h5>Quantity</h5>
        <!-- <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5> -->
      </div>
      <div class="chart-wrapper">
        <div v-if="loadingData" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <highcharts
          ref="backRef"
          v-else
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'"
        />
      </div>
      <div slot="footer">
        <b-button
          :disabled="!showAll"
          class="btn-outline"
          variant="outline-primary"
          left
          @click="(showAll = false), fetchData()"
        >Top 10
        </b-button
        >
        <b-button
          :disabled="showAll"
          class="btn-outline float-right"
          variant="outline-primary"
          right
          @click="(showAll = true), fetchData()"
        >All Data
        </b-button
        >
        <b-button
          class="btn-outline float-right"
          style="margin-right: 10px"
          variant="outline-primary"
          right
          @click="showTableAll()"
        >Table View All Data
        </b-button
        >
      </div>
    </b-card>
  </b-col>
</template>

<script>
import {Switch as cSwitch} from "@coreui/vue";
import Highcharts from "highcharts";
import {Chart} from "highcharts-vue";
import exporting from "highcharts/modules/exporting";
import Datepicker from "vuejs-datepicker";
import DateModal from "../shared/DateModal.vue";
import DateProductManufacturerModal from "../shared/DateProductManufacturerModal.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import {chartFunctionsMixin} from "./addons/chartFunctionsMixin.js";
import {chartOptionsMixin} from "./addons/chartOptionsMixin.js";
import { modelStore, setIsFetching } from '@/stores/modelStore';

exporting(Highcharts);

export default {
  mixins: [chartFunctionsMixin, chartOptionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch,
    DateModal,
    DateProductManufacturerModal,
    LoadingCard,
    HeaderTitle,
    HeaderControl,
  },
  props: [
    "size",
    "offset",
    "title",
    "withDate",
    "withFinancial",
    "chart",
    "chartType",
    "isCompanyOverall",
    "isCompanyProfile",
    "company",
    "mapDateFrom",
    "mapDateTo",
    "city",
    "cityName",
    "model",
    "modelName",
    "units",
    "tested",
    "arrivalDate",
    "warrantyRepair",
    "recycled",
    "equipmentStatus",
    "productType",
    "inventoryStatus",
  ],
  data: () => {
    return {
      dateFrom: "",
      dateTo: "",
      selectedProduct: "",
      selectedManufacturer: "",
      client: "",
      equipment_status: "",
      product_type: "",
    };
  },
 computed: {
    selectedModel() {
      return modelStore.selectedModel;
    },
    flagChanged() {
      return modelStore.isSpaced;
    },
  },
  watch: {
    selectedModel() {
      this.fetchData();
    },
    flagChanged() {
      this.fetchData();
    },
  },
  methods: {
    showTableAll() {
      this.$router.push(
        "/base/Tables/?type=" +
        this.chartType +
        "&date_from=" +
        this.dateFrom +
        "&date_to=" +
        this.dateTo +
        (this.cityName ? "&location=" + this.cityName : "") +
        (this.city ? "&client=" + this.city : "") +
        (this.productType ? "&productType=" + this.productType : "") +
        (this.selectedProduct && this.selectedProduct.id
          ? "&prodModel=" + this.selectedProduct.id
          : "") +
        (this.selectedManufacturer
          ? "&thirdPartyClientId=" + this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',')
          : "") +
        (this.model ? "&fns_part=" + this.model : "")
      );
    },
    onDateProductPickerModalEmit(
      changedDateFrom,
      changedDateTo,
      product,
      manufacturer
    ) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
      this.selectedProduct = product;
      this.selectedManufacturer = manufacturer;
    },
    fetchData() {
      setIsFetching(true);
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      let link = null;

      if (this.city && (!this.units && !this.recycled && !this.warrantyRepair && !this.tested)) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_city.php`;
      } else if (this.model) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_product.php`;
      } else if (this.units) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_units.php`;
      } else if (this.tested) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_tested.php`;
      } else if (this.arrivalDate) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_arrival_date.php`;
      } else if (this.recycled) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/tables/recycled.php`;
      } else if (this.warrantyRepair) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_warranty_repair.php`;
      } else if (this.inventoryStatus) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_inventory_status.php`;
      } else {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/comcast_arc/charts/chart_data.php`;
      }

      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;

      params = {
        type: finType,
        ...((this.chartType !== 'backlog' && this.chartType !== 'inventory_status') ? { date_from: this.from, date_to: this.to } : {}),
        chartType: this.chartType,
        company: this.company ? this.company : "",
        client: this.city,
        client_location: this.cityName,
        equipment_status: this.equipmentStatus,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {}),
        model: this.model,
        productModel: (this.selectedProduct && this.selectedProduct.id) || "",
        thirdPartyClientId: this.selectedManufacturer ? this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',') : "",
      };

      this.$http.get(link, {params}).then(
        (res) => {
          let chart_data = {};
          if (this.chartType === "Shipped") {
            this.chartOptions.id = "Shipped";
          }
          if (this.chartType === "Received") {
            this.chartOptions.id = "receivedEquipment";
            if (res.data.totals === 0) {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                data: null,
              }];
            } else {
              chart_data = res.data;
              this.chartOptions.series[0].colorByPoint = true
            }
          }
          if (this.chartType === "units") {
            this.chartOptions.id = "totalQtySorted";
            chart_data = res.data && !Array.isArray(res.data) ? res.data.dnData[0] : null
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({ name: item[0].replace(/_/g, ' '), y: item[1] })),
                color: "#FF7F50"
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          }
          if (this.tested && this.chartType === "tested") {
            this.chartOptions.id = "testedEquipment";
            chart_data = res.data && !Array.isArray(res.data) ? res.data.dnData[0] : null;
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({
                  name: item[0].replace(/_/g, ' '),
                  y: item[1],
                  color: item[0].toLowerCase().includes('pass') ? "#34db88" : "#db5151"
                })),
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          } else if (this.inventoryStatus && this.chartType === "inventory_status") {
            this.chartOptions.id = "inventoryStatus";
            chart_data = res.data && !Array.isArray(res.data) ? res.data.dnData[0] : null;
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({
                  name: item[0].replace(/_/g, ' '),
                  y: item[1],
                  color: item[0].toLowerCase().includes('rts') ? "#34db88" : "#db5151"
                })),
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          } else if (this.arrivalDate && this.chartType === "arrivalDate") {
            this.chartOptions.id = "arrivalDate";
            chart_data = res.data && !Array.isArray(res.data) ? res.data.dnData[0] : null;
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({
                  name: item[0].replace(/_/g, ' '),
                  y: item[1],
                  color: item[0].toLowerCase().includes('time') ? "#34db88" : "#db5151"
                })),
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          } 
          else if (this.warrantyRepair && this.chartType === "warranty-repair") {
            this.chartOptions.id = "warrantyRepair";
            chart_data = res.data.totals > 0 ? res.data.dnData.find(item => item.id === "Warranty Repair") : null;
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({name: item[0].replace(/_/g, ' '), y: item[1]})),
                color: "#FF7F50"
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          } else if (this.recycled && this.chartType === "recycled") {
            this.chartOptions.id = "recycledEquipment";
            chart_data = res.data.dnData;
            if (chart_data) {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
              this.chartOptions.series = [{
                name: chart_data.name,
                data: chart_data.data.map(item => ({name: item[0].replace(/_/g, ' '), y: item[1]})),
                color: "#db5151"
              }];
            } else {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                name: null,
                data: null,
              }];
            }
          } else if (this.units && this.chartType === "units") {
            this.chartOptions.id = "units";
            chart_data = res.data.sorted;
          } else if (this.chartType === "backlog") {
            this.chartOptions.id = "backlog";
            if (res.data.totals === 0) {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                data: null,
              }];
            } else {
              chart_data = res.data;
              this.chartOptions.series[0].colorByPoint = true
            }
          } else if (this.model && this.chartType === "shipped") {
            this.chartOptions.id = "shipped";
            if (res.data.totals === 0) {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                data: null,
              }];
            } else {
              chart_data = res.data;
              this.chartOptions.series[0].colorByPoint = true
              this.chartOptions.series[0].name = "Locations"
            }
          } else {
            if (res.data.totals === 0) {
              this.chartOptions.title.text = "Total units: 0"
              this.chartOptions.series = [{
                data: null,
              }];
            } else {
              chart_data = res.data;
              this.chartOptions.series[0].colorByPoint = true
            }
          }

          if (
            chart_data &&
            (chart_data.upData || chart_data.dnData || chart_data.totals)
          ) {
            let tmp = chart_data.upData;
            tmp &&
            tmp.length > 0 &&
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                ? -1
                : 1
            );

            // Set colors based on conditions (example)
            tmp = tmp.map((item) => {
              if (item.name === "Recycled") {
                item.color = "#db5151"
                item.name = item.name + " (" + item.locationTotal + ")"
              }
              if (item.name === "Tested") {
                item.color = "#34db88"
                item.name = item.name + " (" + item.locationTotal + ")"
              }
              if (item.name === "Processed") {
                item.color = "#428cff"
                item.name = item.name + " (" + item.locationTotal + ")"
              }
              return item;
            });

            let smp = chart_data.dnData;
            smp && smp.length > 0
              ? smp.forEach((value) => {
                value.data.sort((a, b) =>
                  parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                );
              })
              : "";
            if (tmp && tmp.length > 0)
              if (!this.showAll) {
                this.chartOptions.series[0].data = tmp.slice(0, 100);
              } else {
                this.chartOptions.series[0].data = tmp;
              }
            if (!this.isCompanyProfile) {
              this.chartOptions.drilldown.series = smp;
            }
            if (this.isCompanyOverall) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.isCompanyProfile) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.model) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.units || this.warrantyRepair) {
              // Replace underscores in data
              smp.forEach((item) => {
                item.data.forEach((entry) => {
                  if (typeof entry[0] === "string") {
                    entry[0] = entry[0].replace(/_/g, " ");
                  }
                });
              })
              this.chartOptions.drilldown.series = smp;
            }

            if (finType == "Fin") {
              this.chartOptions.title.text =
                "Total : $" +
                chart_data.totals
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            } else {
              this.chartOptions.title.text = "Total units: " + chart_data.totals;
            }

            setIsFetching(false);
            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          } else {
            setIsFetching(false);
            this.loadingData = false;
          }
        },
        (err) => {
          setIsFetching(false);
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    getFormattedTotalText(finType, total) {
      if (finType === "Fin") {
        return (
          "Total : $" +
          total.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      } else {
        return "Total units: " + total;
      }
    },
    calculateSumFromDrilldown(drilldownData) {
      const total = drilldownData.data.reduce((sum, item) => {
        const match = item[0].match(/\((\d+)\)/); // Regex to extract number inside parentheses
        return sum + (match ? parseInt(match[1], 10) : 0);
      }, 0);
      return total;
    },
  },
  mounted() {
    // Set chart dates if passed from parent component
    this.dateFrom = this.mapDateFrom ? this.mapDateFrom : this.from;
    this.dateTo = this.mapDateTo ? this.mapDateTo : this.to;

    this.client = this.city;
    this.equipment_status = this.equipmentStatus;
    this.product_type = this.productType;

    this.fetchData();

    Highcharts.addEvent(Highcharts.Chart, "drilldown", (e) => {
      let chart = e.target;
      let chartId = e.target.userOptions.id;

      if (!chart.savedOriginalTitle && (chartId === "receivedEquipment" || chartId === "totalQtySorted" || chartId === "units" || chartId === "Shipped" || chartId === "backlog")) {
        chart.savedOriginalTitle = chart.options.title.text;
      }

      let clickedSlice = e.point; // `e.point` is the slice clicked
      let match = clickedSlice.name.match(/\((\d+)\)/); // Extract the number in the parentheses
      let extractedValue = match ? match[1] : null;

      let chart_data = this.chartOptions.drilldown.series;

      if (!chart_data || chart_data.length === 0) {
        return;
      }

      let drilldownData = chart_data.find((d) => d.id === e.point.drilldown);

      if (!drilldownData) {
        return;
      }
      let newTotal = this.calculateSumFromDrilldown(drilldownData);
      if (chartId === "units") {
        e.target.setTitle({ text: this.getFormattedTotalText("Qty", newTotal) });
      } else if (chartId === "receivedEquipment" || chartId === "totalQtySorted" || chartId === "Shipped" || chartId === "backlog") {
        e.target.setTitle({ text: this.getFormattedTotalText("Qty", extractedValue) });
      }
    });
    Highcharts.addEvent(Highcharts.Chart, "drillupall", function () {
      const chart = this;

      if (chart.savedOriginalTitle) {
        chart.setTitle({text: chart.savedOriginalTitle});
      }
    });
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.highcharts-exporting-group {
  display: none !important;
}

/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}

.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
